import { getImageUrl } from '../admin/api/masterApi'

const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 'https://api.trivomtara.com/api'
).replace(/\/$/, '')

/** Map user_news_media rows to the shape expected by public news UI. */
function normalizeNewsArticle(row) {
  if (!row) return null
  const providerName = [row.first_name, row.last_name].filter(Boolean).join(' ').trim()
  const description = row.description || ''
  const platform = row.publication_platform || ''
  const title =
    providerName ||
    platform ||
    (description.length > 80 ? `${description.slice(0, 77)}...` : description) ||
    'News & Media'

  return {
    ...row,
    article_id: row.media_id,
    title,
    short_description: description,
    context: description,
    publication_name: platform,
    publication_platform: platform,
    publication_date: row.publication_date || '',
    provider_name: providerName,
    media_link: Array.isArray(row.video_urls) ? row.video_urls[0] || '' : '',
    media_gallery: Array.isArray(row.media_images) ? row.media_images : [],
    status: 1,
  }
}

export async function fetchNewsArticles() {
  const res = await fetch(`${API_BASE_URL}/user-news-media`)
  const data = await res.json()
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Failed to fetch news articles')
  }
  return (data.data || []).map(normalizeNewsArticle)
}

export async function fetchNewsArticleById(id) {
  const res = await fetch(`${API_BASE_URL}/user-news-media/${id}`)
  const data = await res.json()
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Failed to fetch news article')
  }
  return normalizeNewsArticle(data.data)
}

export function getArticlePrimaryImage(article) {
  const firstImage = article?.media_gallery?.[0]
  return getImageUrl(firstImage)
}

export function formatPublicationDate(date) {
  if (!date) return ''
  return date
}
